import classNames from "classnames";

type FormGroupProps = {
  children: React.ReactNode;
  className?: string;
  isDisabled?: boolean;
};

export const FormGroup = ({
  children,
  className,
  isDisabled,
}: FormGroupProps) => {
  return (
    <fieldset
      disabled={isDisabled}
      className={classNames(className, "flex flex-col gap-3")}
    >
      {children}
    </fieldset>
  );
};
